import { render, staticRenderFns } from "./PurchasedAccProductsTab.vue?vue&type=template&id=b72a04ec"
import script from "./PurchasedAccProductsTab.vue?vue&type=script&lang=js"
export * from "./PurchasedAccProductsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports